export default "__VITE_ASSET__qq4KAkAo__"